import React from 'react';
import { Button } from '../ui/button';
import { getIconSize } from '../../utils/iconMap';

/**
 * İkon + metin — ikon tek başına kalmaz; her zaman görünür etiket ile.
 */
export default function ActionButton({
  icon: Icon,
  children,
  iconClassName,
  className = '',
  variant,
  size,
  ...rest
}) {
  return (
    <Button variant={variant} size={size} className={`inline-flex items-center justify-center gap-2 ${className}`} {...rest}>
      {Icon ? <Icon className={iconClassName || getIconSize('small')} aria-hidden /> : null}
      <span>{children}</span>
    </Button>
  );
}
